module.exports = __webpack_public_path__ + "img/img60.1cb9721c.svg";